import React, { useEffect, useState } from 'react'
import Dialog from '../../../lib/Dialog'
import general from '../../../general'
import Image from '../../../lib/Image'
import Subtitle from '../../components/Subtitle'
import ReceiveAlert from './ReceiveAlert'
import { NavLink } from '../../../lib/Navigation'
import { useScroll } from 'ahooks'
import $ from 'jquery'
import useActiveState from '../../../lib/useActiveState'
import SelectAccount, { useSelectAccount } from '../../components/alert/SelectAccount'
import { showDownloadGameAlert } from '../../components/alert/XHModalShow'
import GameTags from '../../components/game/GameTags'

export default function GameList(props) {

  const [data, setData] = useState()
  const [game_list, setgame_list] = useState([])
  const [tag_id, settag_id] = useState('')
  const [init, setInit] = useState(false)
  const [visible,setVisible] = useState(false)
  const [receiveData,setReceiveData] = useState()
  const [more,setMore] = useState(true)
  const [page,setPage] = useState(1)
  const [load,setLoad] = useState(false)
  const [refresh,setRefresh] = useActiveState('receive-refresh')

  const getData = (tag,pages) => {
    if (load){
      return
    }
    setLoad(true)
    Dialog.loading()
    general.axios.post('/base/signbonusV2/get648GiftAndVoucher', {
      id: '',
      tag_id:tag,
      pagination:{
        page:pages,
        count:20
      }
    })
      .finally(() => {
        Dialog.close()
      })
      .then((res) => {
        const { data, status } = res.data
        if (status.succeed) {
          setLoad(false)
          setInit(true)
          setData(data)
          setgame_list(() => pages == 1 ? res.data.data.game_list : [...game_list, ...res.data.data.game_list]);
          setPage(pages)
          let {paginated} = data;
          setMore(paginated.more);
          if (props.handleShow){
            props.handleShow()
          }
        } else {
          Dialog.error(status.error_desc)
        }
      })
  }

  const scroll = useScroll()
  useEffect(()=>{
    if (props.active){
      if (scroll.top < -80) {
        getData(tag_id,1);
      }
      if (scroll.top + window.innerHeight + 20 > $(document).height() && more) {
        getData(tag_id, page + 1);
      }
    }
  },[scroll,props.active])

  useEffect(() => {
    if (props.active && !init) {
      getData(tag_id,1)
    }
  }, [props.active,init])

  const handleTag = (item) => {
    settag_id(item.id)
    getData(item.id,1)
  }

  const receive = (game,xh) => {
    if (game.isreceived){
      return
    }
    Dialog.loading()
    const tmp = {
      packid: game.packid || '',
      voucherId:game.voucherId || '',
      claim_type: game.claim_type,
      topic_id: game.maiyou_gameid,
      trumpet_name:xh?.xh_username
    }
    general.axios.post('/base/signbonusV2/receive', tmp).finally(() => {
      Dialog.close()
    }).then((res) => {
      const { data, status } = res.data
      if (status.succeed) {
        const info = {...data, game_id: game.game_id}
        setReceiveData(info)
        setVisible(true)
        // game_list.map(item => {
        //   if (item.game_id == game.game_id) {
        //     item.isreceived = true
        //   }
        //   return item
        // })
        // setgame_list([...game_list])
        setRefresh(e=>!e)
      } else {
        Dialog.error(status.error_desc)
      }
    })
  }

  const [topic_id,setTopic_id] = useState("")
  const [game,setGame] = useState()
  const {visibleChange,appendTopic_id} = useSelectAccount()

  const handleRequetXHData = (xhlist) => {
    if (xhlist.length == 0){
      showDownloadGameAlert().then(() => {
        general.history.push('/game?id=' + game.game_id)
      })
    }else if (xhlist.length == 1){
      handleReceive(xhlist[0])
    }else {
      visibleChange(true,topic_id)
    }
  }

  const handleCompletion = (xh) => {
    handleReceive(xh)
  }

  const handleReceive = (xh) => {
    receive(game,xh)
  }

  return (
    <div className="game-list">
    <SelectAccount topic_id={topic_id} handleRequetXHData={handleRequetXHData} handleCompletion={handleCompletion}></SelectAccount>
      <div className='list-header'>
        {data?.tag.map(item => {
          return (
            <div key={item.id} onClick={() => handleTag(item)} className={'tag ' + (tag_id == item.id ? 'active' : '')}>
              <div className="name">{item.tagname}</div>
            </div>
          )
        })}
      </div>
      <div className="games">
        {game_list?.map(game => {
          return (
            <div key={JSON.stringify(game)} className='item'>
              <div className="game">
                <NavLink user={false} to={`/game?id=${game.game_id}`}>
                  <Image className="icon" src={game.game_image.thumb} />
                </NavLink>
                <NavLink user={false} to={`/game?id=${game.game_id}`} className="text">
                  <div className="name">{game.game_name}</div>
                  <div className="info1">
                    {game.game_classify_type.trim()}
                    <Subtitle>{game.nameRemark}</Subtitle>
                  </div>
                  <GameTags game={game}></GameTags>
                </NavLink>
                <div className="action">
                  <NavLink className={"btn " + (game.isreceived ? 'disable' : '')} onClick={() => {
                    if (game.isreceived){
                      return
                    }
                    setTopic_id(appendTopic_id(game.maiyou_gameid))
                    setGame(game)
                  }}>{game.button}</NavLink>
                  {!game.isreceived && <div className="btn-desc">{game.but_desc}</div>}
                </div>
              </div>
            </div>
          )
        })}
      </div>
      {game_list?.length > 0 && !more ? <div className="view-end">别撩啦！已经到底啦~</div> : null}
      {visible && <ReceiveAlert receiveData={receiveData} action={()=>setVisible(false)} visible={visible}></ReceiveAlert>}
    </div>
  )
}
